<template>
  <div class="row">
    <div class="left-column"></div>
    <div class="right-column">
      <div class="main-input-form-container">
        <div class="gemnote-logo">
          <a href="https://www.gemnote.com/" target="_blank" rel="noreferrer">
            <img src="../assets/gemnote_logo_pebble.png" alt="logo" />
          </a>
        </div>

        <div class="arrow-link" v-if="!isSuccess">
          <router-link to="/login">
            <span>Back </span>
          </router-link>
        </div>

        <!-- Successful Reset Here -->
        <section v-if="isSuccess">
          <h3 class="sent">{{ $t('reset-pwd.ui.sent') }}</h3>

          <p class="text-left">
            Check your inbox and follow instructions to reset your password.
          </p>

          <p class="resend text-left">
            Didn’t receive it?
            <strong @click="resetPassword">Resend</strong>
          </p>
        </section>

        <!-- Reset FOrm Here -->
        <form v-else @submit.prevent="resetPassword">
          <h3>{{ $t('reset-pwd.ui.title') }}</h3>
          <p class="message">
            No worries, enter the email address associated with your account and
            we’ll send you instructions to reset your password.
          </p>
          <div class="form-group">
            <input
              type="email"
              data-testid="email-input"
              :placeholder="$t('reset-pwd.ui.email-placeholder')"
              class="form-control"
              v-model="userEmail"
            />
          </div>
          <div class="reset-button">
            <button
              data-testid="reset-button"
              class="button-gemnote button-gemnote--small"
              :class="{ 'button-gemnote--disabled': isRequestingReset }"
              :disabled="isRequestingReset"
            >
              <span>{{ $t('reset-pwd.ui.btn-reset') }}</span>
            </button>
          </div>
        </form>
      </div>

      <div class="footer-links">
        <FooterLinks />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts } from '@/helpers'
import FooterLinks from '@/components/Universal/FooterLinks'

export default {
  name: 'ResetPassword',
  components: { FooterLinks },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  },

  data: () => ({}),

  computed: {
    userEmail: {
      get() {
        return this.$store.state.auth.userEmail
      },
      set(value) {
        this.$store.dispatch('auth/setUserEmail', value)
      }
    },

    ...mapState({
      isRequestingReset: state => state.auth.isRequestingReset,
      isSuccess: state => state.auth.isRequestingSuccess
    })
  },

  methods: {
    resetPassword(event) {
      this.$store.dispatch('auth/resetPassword', {
        email: this.userEmail,
        event
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

h3 {
  font-size: 2.5rem;
  font-weight: 400;
  text-align: left;
  padding-bottom: 2rem;

  &.sent {
    padding-top: 2.75rem;
  }
}

.resend {
  padding-top: 1.75rem;
  font-size: 0.875rem;

  strong {
    cursor: pointer;
    text-decoration: underline;
  }
}
.button-gemnote--small {
  height: 2.5rem;
  width: auto;
  padding: 0 1rem;
  font-weight: 500;
}
.arrow-link {
  margin-top: 2.5rem;
}

.link {
  font-family: $inter;
}

.row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  grid-template-rows: auto;
  height: 100vh;
}

.right-column {
  background: $main-white;
  flex-direction: column;
  display: flex;
  justify-content: space-between;

  .footer-links {
    padding: 0 8rem 2rem 8rem;
  }
}

.left-column {
  background: url('../assets/Gemnote_SignOn_1.png');
  background-size: cover;
  background-position: center;
}

.gemnote-logo {
  text-align: left;

  a {
    &:hover {
      opacity: 1;
    }
  }

  img {
    height: 4.25rem;
  }
}

.main-input-form-container {
  padding: 8rem;
}

form {
  margin-top: 3rem;

  .form-group {
    width: 50%;

    input {
      font-size: 1rem !important;
      font-family: $inter;

      &::placeholder {
        font-weight: 400 !important;
        color: #232220;
        opacity: 0.4;
      }
    }
  }

  .message {
    padding-bottom: 2rem;
  }

  .reset-button {
    padding: 1rem 0;
    text-align: left;
  }

  p {
    text-align: left;
  }
}

@media screen and (max-width: 1500px) and (min-width: 900px) {
  .main-input-form-container {
    padding: 6rem;
  }

  .footer-links {
    padding: 6rem !important;
  }
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    transition: 1s ease-in;
  }

  .left-column {
    height: 50vh;
  }

  .right-column {
    height: 50vh;
  }

  .gemnote-logo {
    padding-bottom: 1rem;
  }

  .main-input-form-container {
    padding: 2rem;
  }

  .footer-links {
    padding: 2rem !important;
  }

  form {
    .reset-button {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    p {
      margin: 0rem 0rem;
    }
  }
}

@media (max-width: 575.98px) {
  .form-group {
    width: 100% !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .form-group {
    width: 100% !important;
  }
}
</style>
